// Overlay use className props to pass style properties to child component.
// To make this component work add className props to your child component manually.
// Here an example: https://gist.github.com/Miniplop/8f87608f8100e758fa5a4eb46f9d151f

import React from "react";
import BadgesProjects from "../BadgesProjects/BadgesProjects/BadgesProjects";
import Etiqueta from "../EtiquetaInvertir/EtiquetaInvertir";
import styles from "./CardProyect.module.css";
import "./CardProyect.css";
import { formatCurrencyCOP, formatNumber } from "../../helpers/FormatNumber";
import hideImage from "../../assets/hideImage.png";
import NewProject from "../NewProject/NewProject";

const CardResumen = ({ data }) => {
  return (
    <div className={`${styles.cardResumen} ${data.hasInvestment ? 'card-invested' : 'card-available'}`}>
      <div className={styles.contentCard}>
        <div className={styles.frame551}>
          <div className={styles.image}>
            <img
              alt=""
              className={styles.img}
              src={data.image ?? hideImage}
              onError={(e) =>
                (e.target.onerror = null)(
                  (e.target.src =
                    "/static/media/no-image-svgrepo-com.58c9eca73333ce7a54db1faf164b0074.svg")
                )
              }
            />
            {/* Overlay para fondos invertidos */}
            {data.hasInvestment && (
              <div className="invested-overlay">
                <div className="invested-badge">
                  <span>✓ Ya inviertes aquí</span>
                </div>
              </div>
            )}
          </div>
          <div className={styles.frame550}>
            <div className="float-labels">
              <div className="float-label-left">
                <Etiqueta hasInvestment={data.hasInvestment} />
              </div>
              <div className="float-label-right">
                <BadgesProjects text={data.fund_type ?? ""} />
              </div>
              <div className="float-label-bottom">
                {typeof data.nuevo !== 'undefined' && (
                  <span
                    style={{
                      display: 'inline-block',
                      background: data.nuevo ? '#00B8D9' : '#27AE60',
                      color: '#fff',
                      borderRadius: 8,
                      padding: '2px 10px',
                      fontWeight: 600,
                      fontSize: 12,
                      marginLeft: 4
                    }}
                  >
                    {data.nuevo ? 'Nuevo' : 'En operación'}
                  </span>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className={styles.frame562}>
          <div className={styles.dataCard}>
            {data.hasInvestment && (
              <div className="my-investment-info">
                <span className="my-investment-label">Tu inversión:</span>
                <span className="my-investment-amount">{formatCurrencyCOP(data.investedAmount)}</span>
              </div>
            )}
            <div className={styles.frame558}>
              <div className={styles.nombreYPrecio}>
                <label className={styles.body1}>
                  {data.name ?? "No disponible"}
                </label>
                <label className={styles.body1Bold}>
                  {formatCurrencyCOP(data.price_per_unit * data.amount_units)}
                </label>
              </div>
              <div className={styles.ubicacionYLabel}>
                <label className={styles.caption}>
                  {data.gestor ?? "No disponible"}
                </label>
                <label className={styles.captionTwo}>Valor del fideicomiso</label>
              </div>
            </div>
            <div className={styles.dataCard}>
              <div className={styles.indicadores}>
                <p className={styles.body2Bold} style={{ marginTop: 0 }}>
                  {formatCurrencyCOP(data.price_per_unit)}{" "}
                </p>
                <div className={styles.indicadorRendimiento}>
                  <label className={styles.body2Bold}>
                    {formatNumber(data.expected_return)}%
                  </label>
                </div>
              </div>
              <div className={styles.labels}>
                <p className={styles.captionThree} style={{ width: "173px" }}>
                  Valor promedio de la unidad
                </p>
                <p className={styles.captionFour}>Rentabilidad esperada</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CardResumen;
